import { ref } from "vue";

const isOpen = ref(false);

const toggleChatbot = () => {
  isOpen.value = !isOpen.value;
};

const closeChatbot = () => {
  isOpen.value = false;
};

export function useChatbotUI() {
  return {
    isOpen,
    toggleChatbot,
    closeChatbot
  };
}
